import { MultipleReverseGeocodingArgs } from '../hereMaps';

const maxLocationsPerRequest = 100;

export const batchGeocodingLocations = (locations: MultipleReverseGeocodingArgs) => {
  const chunks = [];

  for (let i = 0; i < locations.length; i += maxLocationsPerRequest)
    chunks.push(locations.slice(i, i + maxLocationsPerRequest));

  return chunks;
};
